import Constants from '../../utils/Constants'

const state = {
  title: '',
  meta: [],
  label: {},
  footType: [],
  orderType: {},
  directory: {}
}

const getters = {
  get: state => {
    return state
  }
}

const actions = {
  set ({ commit }, metaData) {
    commit('set', metaData)
  }
}

const mutations = {
  set (state, metaData) {
    const logoFlag = Constants.getSite('logo_flag')
    let title = metaData['title']
    // フラグが取得出来た場合はシステムタイトルを付与
    if (logoFlag) {
      title = title + ' | ' + (logoFlag === '0' ? Constants.getSite('browser_title') : 'Shopping Scan')
    }
    state['title'] = title
    let array = [].concat(Constants.Meta)
    if (metaData['meta']) array = array.concat(metaData['meta'])
    state['meta'] = array
    state['label'] = Constants.Label
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
